import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Col, Container, Modal, Row } from "react-bootstrap";
import Header2 from "../../components/Header2";
import { FiEdit } from "react-icons/fi";
import "react-datepicker/dist/react-datepicker.css";
import { ProfileContext } from "../../context/ProfileContext";
import { useForm } from "react-hook-form";
import { IMAGE_URL } from "../../API";
import avtar from "../../Assets/Images/image copy 2.png"
import { AiOutlineMail } from "react-icons/ai";
import { LuPhone } from "react-icons/lu";
import { IoMdCloseCircle } from "react-icons/io";
import AddStripeCard from "./AddStripeCard";
import { useStripeCards } from "../../hooks/profile/useStripeCard";
import { useMedicalHistoryUpload } from "../../hooks/profile/useMedicalHistoryUpload";
import { MdOutlineLocationOn } from "react-icons/md";

function ProfilePage() {
  const { profile, allDoctors, TOKEN, getPastHistory, hasSubbmittedHistory, headers } = useContext(ProfileContext);
  const navigate = useNavigate()
  const stripe = useStripeCards(profile, headers);
  const medical = useMedicalHistoryUpload(TOKEN, getPastHistory);

  const { reset } = useForm();
  const handlechanges = () => { navigate('/edit-profile') }
  const handleRedirect = () => { navigate("/profile") }


  useEffect(() => { if (profile && Object.keys(profile).length > 0) { reset(profile); } }, [profile, reset]);
  useEffect(() => { if (hasSubbmittedHistory === false) { medical.setShow(true) } }, [hasSubbmittedHistory]);

  const renderMedicalHistory = (keyName, profile) => {
    if (!keyName) return null;

    return Object.keys(keyName)
      .filter((key) =>
        keyName[key] === true ||
        key === 'drug_use_frequency' ||
        (key === 'others' && keyName?.others_specify) ||
        (key === 'orthopedic_surgery' && keyName?.orthopedic_specify)
      )
      .map((key, index, arr) => {
        let text = '';

        if (key === 'others' && keyName?.others_specify) { text = `${key.replace(/_/g, ' ')}: ${keyName.others_specify}` }
        else if (key === 'orthopedic_surgery' && keyName?.orthopedic_specify) { text = `${key.replace(/_/g, ' ')}: ${keyName.orthopedic_specify}` }
        else if (key === 'former_smoker' && profile?.quit_date) { text = `Former Smoker (Quit Date: ${new Date(profile.quit_date).toISOString().split('T')[0]})` }
        else if (key === 'drug_use_frequency' && keyName?.drug_use_frequency) { text = `Drug Use: ${keyName.drug_use_frequency} times/week` }
        else if (!['drug_use_weekly', 'drug_use_frequency'].includes(key)) { text = key.replace(/_/g, ' ') }
        else { return null }

        return (
          <h5 key={key}>
            {text}
            {index < arr.length - 1 ? ', ' : ''}
          </h5>
        );
      });
  };
  return (
    <>
      {/* <Loader isLoading={isLoading}/> */}
      <div className="comm_page_outer2">
        <Container>
          <Header2 />
          <div className="comm_inner_page_layout">
            <section className="comm_form_border_box_row">
              <div className="comm_border_box">
                <div className="profile_main_page">
                  <div className="d-flex my_profile_row">
                    <div className="comm_profile_head_usr_detail">
                      <div className="profile-pic">
                        <Form.Control id="file" type="file" name="profile_picture" />
                        <figure className="profile-img-edit">
                          <img src={profile.image ? `${IMAGE_URL}${profile.image}` : avtar} alt="User" className="img-fluid" />
                        </figure>
                      </div>
                      <div className="name-all">
                        <h6>{profile.full_name}</h6>
                        <p><AiOutlineMail /> {profile.email}</p>
                        <p><LuPhone /> {profile.number}</p>
                        <p className="text-capitalize"><MdOutlineLocationOn size={18} />{profile.address}</p>
                      </div>
                    </div>

                    <div className="comm-pair-btns d-flex align-items-center gap-3">
                      <button onClick={handlechanges} className="main-btn comm_icon_btn edit_profile_btn">
                        <FiEdit /> Edit Profile
                      </button>
                      <Link to="/change-password" className="main-outline-btn">Change Password</Link>
                    </div>
                  </div>
                </div>
              </div>

              {/* Basic information */}
              <div className="comm_border_box">
                <div className="d-flex comm_profile_top_head">
                  <h4 className="comm_inner_form_heading">Basic Information</h4>
                  <button onClick={handleRedirect} className="main-btn comm_icon_btn edit_profile_btn edit_profile_btn2">
                    <FiEdit /> Edit
                  </button>
                </div>
                <div className="patient-age-name d-flex">
                  <div className="patient-anme-view">
                    <p>DOB</p>
                    <h5>{profile.dob}</h5>
                  </div>
                  <div className="patient-anme-view">
                    <p>Blood Group</p>
                    <h5>{profile.blood_group}</h5>
                  </div>
                  <div className="patient-anme-view">
                    <p>Gender</p>
                    <h5>{profile.gender}</h5>
                  </div>
                  <div className="patient-anme-view">
                    <p>Age</p>
                    <h5>{profile?.age}</h5>
                  </div>
                  <div className="patient-anme-view">
                    <p>Height (cms)</p>
                    <h5>{profile.height}</h5>
                  </div>
                  <div className="patient-anme-view">
                    <p>Weight (kgs)</p>
                    <h5>{profile.weight}</h5>
                  </div>
                  <div className="patient-anme-view">
                    <p>Primary Care Provider</p>
                    <h5> {allDoctors.find(doc => doc._id === profile.primary_care_provider)?.name || "Not Assigned"}</h5>
                  </div>
                  <div className="patient-anme-view">
                    <p>Pharmacy</p>
                    <h5>{profile.pharmacy}</h5>
                  </div>
                </div>
              </div>

              {/* Past Medical History */}
              <div className="comm_border_box">
                <div className="d-flex comm_profile_top_head single_prof_top_head">
                  <h4 className="comm_inner_form_heading">Past Medical History</h4>
                  <Link to="/past-medical-history" className="main-btn comm_icon_btn edit_profile_btn edit_profile_btn2">
                    <FiEdit /> Edit
                  </Link>
                </div>
                <div className="patient-age-name past_medical_history_view d-flex">
                  <div className="patient-anme-view">
                    <p>Please check any condition you have or have had?</p>
                    {profile.no_medical_history ?
                      (<span>No medical history</span>)
                      :
                      (<span>{renderMedicalHistory(profile.medical_history, profile)}</span>)}
                  </div>
                  <div className="patient-anme-view">
                    <h4 className="comm_inner_form_heading">Past Surgical History</h4>
                    <p>Please check any surgery you have had?</p>
                    {profile.never_had_surgery ? (<span>never had  surgery</span>) : (<span>{renderMedicalHistory(profile.surgical_history, profile)}</span>)}
                  </div>
                  <div className="patient-anme-view">
                    <h4 className="comm_inner_form_heading">Social History</h4>
                    <div className="patient-anme-view-inner">
                      <div>
                        <p>Please check for smoking pattern.</p>
                        {profile.never_smoker ? (<span>No Smoking</span>) : (<span>{renderMedicalHistory(profile.social_history, profile)}</span>)}
                      </div>
                      <div>
                        <p>Please check for drink/alcohol pattern.</p>
                        {profile.non_alcoholic ? (<span>non alcoholic</span>) : (<span>{renderMedicalHistory(profile.alcohol_history, profile)}</span>)}
                      </div>
                      <div>
                        <p>Please check for drug pattern.</p>
                        {profile.non_druggist ? (<span>No drugs</span>) : (<span>{renderMedicalHistory(profile.drug_history, profile)}</span>)}
                      </div>
                    </div>
                  </div>
                  <div className="patient-anme-view">
                    <h4 className="comm_inner_form_heading">Family History</h4>
                    <p>Please write in any medical condition or disease that has been in your family</p>
                    {profile?.family_history?.map((field, index) => (
                      <span key={index}>
                        {field.family_member} had {field.disease}<br />
                      </span>
                    ))}
                  </div>
                  <div className="patient-anme-view">
                    <h4 className="comm_inner_form_heading">Current Medications</h4>
                    {profile.no_medication ?
                      (<span>No current medications</span>)
                      :
                      (profile?.current_medications?.map((field, index) => (
                        <span key={index}>
                          Medication: {field.medication},
                          Strength (Dose): {field.strength} {field.dosage_form || ''},
                          Frequency: {field.frequency}
                        </span>
                      )))
                    }
                  </div>
                  <div className="patient-anme-view">
                    <h4 className="comm_inner_form_heading">Medication Allergies</h4>
                    {profile.no_medication_allergy ?
                      (<span>No known medication allergies</span>)
                      :
                      (profile?.medication_allergy?.map((field, index) => (
                        <span key={index}>
                          Medication: {field.medication},
                          Reaction: {field.reaction},
                        </span>
                      )))
                    }
                  </div>
                </div>
              </div>

              {/* Stripe Card Information */}
              <div className="comm_border_box">
                {stripe.savedCards.length > 0 && (
                  <div className="container py-4">
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                      <h5 className="text-success fs-2 fw-bold mb-4">Your Saved Cards</h5>
                      {stripe.savedCards.map((card) => (
                        <div
                          key={card.id}
                          className={`card mb-3 border-0 shadow-sm rounded-4 ${stripe.selectedCard === card.id ? "border border-success" : ""}`}
                          style={{ cursor: "pointer", borderWidth: "2px" }}
                          onClick={() => stripe.handleSelectCard(card.id)}
                        >
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex align-items-center gap-3">
                                <input type="radio" name="selectedCard" checked={stripe.selectedCard === card.id} />
                                <div>
                                  <span className="fw-bold fs-3 text-dark"> {card.card.brand?.toUpperCase()}</span>
                                  {stripe.selectedCard === card.id && (<span className="badge bg-success ms-2 fs-5 ">Selected</span>)}
                                  <h6 className="text-muted fs-4 fw-bold">Credit / Debit Card</h6>
                                </div>
                              </div>

                              <div className="text-end">
                                <span className="fw-bold fs-3 text-dark">•••• {card.card.last4}</span>
                                <h6 className="text-muted fs-4 fw-bold">Exp: {card.card.exp_month}/{card.card.exp_year}</h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <button onClick={() => { stripe.createSetupIntent(); stripe.setShowForm(true) }}
                        className="main-btn mt-4 w-100 p-1">+ Add New Card</button>
                    </div>
                  </div>
                )}
                <AddStripeCard
                  loading={stripe.loading}
                  clientSecret={stripe.clientSecret}
                  showForm={stripe.showForm}
                  stripePromise={stripe.stripePromise}
                  getSavedCards={stripe.getSavedCards}
                  setShowForm={stripe.setShowForm}
                />
              </div>
            </section>
          </div>
        </Container>
      </div>

      <Modal show={medical.show} onHide={medical.toggleShow} centered className="comm_modal logout_modal">
        <Modal.Body className="p-0">
          <Modal.Header><IoMdCloseCircle onClick={medical.toggleShow} /></Modal.Header>
          <div className="comm_inner_body_modal px-5">
            <h4> Please upload past medical history! </h4>
            <Row>
              <Col md={6}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Age</Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter Your Age e.g 18"
                    min={1}
                    max={125}
                    value={medical.age}
                    onChange={(e) => medical.setAge(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Select Your Gender</Form.Label>
                  <Form.Select value={medical.gender} onChange={(e) => medical.setGender(e.target.value)}>
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="others">Others</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="comn-class-inputs">
                  <Form.Label>Upload PDF</Form.Label>
                  <Form.Control type="file" accept="application/pdf" onChange={medical.handleFileChange} />
                </Form.Group>
              </Col>
            </Row>

            {medical.error && <span className="error d-block text-center mt-3">{medical.error}</span>}

            <div className="modal_pair_btns">
              <button className='main-outline-btn' onClick={medical.toggleShow} disabled={medical.uploading}>No</button>
              <button className="main-btn" onClick={medical.uploadMedicalHistory} disabled={medical.uploading}>{medical.uploading ? "Uploading..." : "Yes"}</button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default ProfilePage;
